<script setup lang="ts">
import { WhatsappIcon } from 'assets/data/icons';
const Icon = useIcon();
</script>
<template>
  <Icon :path="WhatsappIcon" :size="24" class="w-7" filled />
</template>
